<template>
  <div class="lineup-undo-container">
    <p>Undo changes for the lineup:</p>
    <p>{{ data.product }}<br />{{ data.name }}</p>
    <div class="submit-actions">
      <button class="mds-button" type="button" @click="closeModal">
        Cancel
      </button>
      <mds-button variation="primary" @click="doUndo" class="undo-button">
        Undo Lineup Changes
      </mds-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import * as LineupsFundsService from '@/services/LineupsFunds';

export default {
  name: 'lineup-undo-changes',
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      fiduciaryId: (state) => state.user.fiduciary.id,
    }),
  },
  methods: {
    ...mapActions({
      closeModal: 'closeModal',
    }),
    doUndo() {
      const payload = this.data.funds;
      LineupsFundsService.lineupUndoChanges({
        fiduciaryId: this.fiduciaryId,
        payload,
      }).then((result) => {
        if (result.status.success) {
          // force the grid to reload
          this.$store.dispatch('setReloadNeed', true);
          this.$store.dispatch('openNotification', {
            message: 'Lineup update has been undone',
          });
        }
      }).catch((error) => {
        const httpStatus = (error?.response.status) ? (error?.response.status) : (error?.status);
        if (httpStatus === 401) {
          this.$router.push('/Login');
        }
      }).finally(() => {
        this.closeModal();
      });
    },
  },
};
</script>
<style lang="scss">
.lineup-undo-container {
  @include mds-body-text-m();

  .undo-button {
    margin-left: $mds-space-1-and-a-half-x;
  }
}

</style>
